import React from 'react';

import Container from '../Container';
import Image from '../Image';
import Typography from '../Typography';
import BackToTop from '../BackToTop';
import {
  gtmAttributesInstagram,
  gtmAttributesYoutube,
  gtmAttributesFacebook,
  gtmAttributesLinkedin,
} from '../../utils/gtmVariables';

import useGTMEventsTracker from '../../hooks/useGTMEventsTracker';

interface FooterProps {
  logo: string;
  instagramSvg: string;
  youtubeSvg: string;
  facebookSvg: string;
  linkedinSvg: string;
  titleSocialMedias: string;
  legalText: string;
  FrequentQuestions?: string;
  FrequentQuestionsLink?: string;
}

const Footer = ({
  logo,
  instagramSvg,
  youtubeSvg,
  facebookSvg,
  linkedinSvg,
  titleSocialMedias,
  legalText,
  FrequentQuestions,
  FrequentQuestionsLink,
}: FooterProps) => {
  const GTMEventsTracker = useGTMEventsTracker();

  return (
    <footer>
      <div className="relative bg-primary py-11 max-sm:py-12">
        <Container>
          <div className="flex justify-between items-start max-sm:block">
            <div>
              <Image
                images={[
                  {
                    link: '/',
                    img: `${logo}`,
                    alt: 'marketplace-logo',
                    id: 'mp__footer-link-logo',
                  },
                ]}
              />
            </div>
            <div className="flex flex-col max-sm:mt-8">
              <span
                id="mp__footer-title-social"
                className="text-sm text-neutral-lightest max-sm:text-xs"
              >
                {titleSocialMedias}
              </span>
              <div className="flex gap-2 items-center mt-2">
                {[
                  {
                    href: 'https://www.instagram.com/grupocasasbahia/',
                    img: instagramSvg,
                    alt: 'instagram',
                    gtm: gtmAttributesInstagram,
                    id: 'mp__footer-link-instagram',
                  },
                  {
                    href: 'https://www.youtube.com/c/ViaMarketplace',
                    img: youtubeSvg,
                    alt: 'youtube',
                    gtm: gtmAttributesYoutube,
                    id: 'mp__footer-link-youtube',
                  },
                  {
                    href: 'https://www.facebook.com/marketplacevia',
                    img: facebookSvg,
                    alt: 'facebook',
                    gtm: gtmAttributesFacebook,
                    id: 'mp__footer-link-facebook',
                  },
                  {
                    href: 'https://www.linkedin.com/company/viaimaginecaminhos',
                    img: linkedinSvg,
                    alt: 'linkedin',
                    gtm: gtmAttributesLinkedin,
                    id: 'mp__footer-link-linkedin',
                  },
                ].map(({ href, img, alt, gtm, id }) => (
                  <a
                    key={alt}
                    id={id}
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() => GTMEventsTracker(gtm)}
                    className="flex h-10 w-10 items-center justify-center"
                  >
                    <img src={img} alt={alt} />
                  </a>
                ))}
              </div>
            </div>
          </div>
          <div className="flex items-center gap-4 my-2">
            <div className="flex-1">
              <hr className="bg-neutral-light opacity-100 max-sm:m-0" />
            </div>
            <BackToTop />
          </div>
          <div className="flex justify-between items-center max-sm:block max-sm:pt-0">
            <div className="max-w-[37%] max-sm:mt-8 max-sm:mb-[10px] max-sm:max-w-[80%] max-[300px]:max-w-full min-[1440px]:max-w-[33%]">
              <span
                id="mp__footer-text-company-info"
                className="font-sans text-neutral-lightest text-sm max-sm:text-xs"
              >
                {legalText}
              </span>
            </div>
            <div className="max-sm:w-full">
              <div className="flex flex-wrap gap-x-5 gap-y-2 max-sm:mt-4 max-sm:pl-0">
                {FrequentQuestions &&
                  (FrequentQuestionsLink ? (
                    <a
                      href={FrequentQuestionsLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="font-sans text-xs text-neutral-lightest no-underline cursor-pointer font-normal"
                    >
                      <Typography variant="caption">{FrequentQuestions}</Typography>
                    </a>
                  ) : (
                    <span className="font-sans text-xs text-neutral-lightest no-underline cursor-pointer font-normal">
                      <Typography variant="caption">{FrequentQuestions}</Typography>
                    </span>
                  ))}
              </div>
            </div>
          </div>
        </Container>
      </div>
    </footer>
  );
};

export default Footer;
